module.exports = __webpack_public_path__ + "assets/img/renshu.831ca585.png";